import React from 'react';
import { Button, Modal } from 'antd';
import s from './s.module.less';

/**
 * 上线公告。设计稿把它定义为「launch 时每个 provider 都会看到一次」
 * （原型 index.html:73「What every provider sees at launch」+ showAnnouncement()）。
 *
 * 「看过」记在 localStorage —— 沿用本仓既有做法（CredentialingPage/GrowthBanner、
 * ProviderHomePage/OnboardingPopups 都是这么记的），不新建后端字段。
 * 代价是换浏览器 / 换设备会再看到一次；现有那几个横幅本来就是这个行为，保持一致。
 */
const LS_KEY = 'kh-patient-booking-limit-announcement-seen';

export const announcementSeen = (): boolean => {
    try {
        return localStorage.getItem(LS_KEY) === '1';
    } catch (e) {
        // 隐私窗口 / 站点数据被禁时读写都会抛。读不到就按「没看过」处理
        return false;
    }
};

export const markAnnouncementSeen = (): void => {
    try {
        localStorage.setItem(LS_KEY, '1');
    } catch (e) {
        // 记不住就算了，绝不能因为存不下而挡住页面
    }
};

interface Props {
    open: boolean;
    /** 「Not now」：只关掉 */
    onLater: () => void;
    /** 「Set a limit」：关掉 + 打开草稿开关 + 聚焦数字框（原型 focusCap(true)） */
    onSetUp: () => void;
}

const AnnouncementModal: React.FC<Props> = ({ open, onLater, onSetUp }) => (
    <Modal
        open={open}
        title="Set a limit on new marketplace patients"
        width={560}
        closable={false}
        maskClosable={false}
        onCancel={onLater}
        className={s.modalShell}
        footer={[
            <Button key="later" onClick={onLater}>
                Not now
            </Button>,
            <Button key="setup" type="primary" onClick={onSetUp}>
                Set a limit
            </Button>,
        ]}
    >
        {/* 三段正文逐字取自原型 showAnnouncement()（patient-limits.html:1014-1015），
            只把 HelloKlarity 换成 Klarity Health（全站口径） */}
        <p className={s.announceP}>
            You can now choose up to how many new patients from the Klarity Health marketplace can
            book you in a week, so a busy stretch does not fill more of your schedule than you want.
        </p>
        <p className={s.announceP}>
            When that many new patients have booked, your profile is hidden from marketplace search,
            so no more new patients can book. It shows again the next Monday. You can raise the
            number at any time to show it sooner. The limit is separate from Pro-Listing and does not
            change your Pro-Listing budget or bids.
        </p>
        <p className={s.announceP}>
            Nothing changes until you turn the limit on. Right now you have no limit.
        </p>
    </Modal>
);

export default AnnouncementModal;
